import React from 'react';
import { Formik, Form } from 'formik';
import appState from '../../state/AppStateContainer';
import { serviceProfile } from '../../services/service-profile';
import _ from 'lodash';
import '../app-create-project/app-create-project.css';
import './add-member.css';
import { NotificationManager } from 'react-notifications';
import BtGrid from '../bt-grid/bt-grid';
import BtRow from '../bt-row/bt-row';
import BtColumn from '../bt-column/bt-column';
import Field from '../../components/shared/Field/Field';
import Selector from '../../components/shared/Selector/Selector';
import { validateEmail } from '../../util';
import { withTranslation } from 'react-i18next';
import appEnum from '../../util/appEnum';

class AddMember extends React.Component {
  superAdminRolesDropdown = [];
  userRolesDropdown = [];

  constructor(props) {
    super(props);
    this.state = {
      data: {
        email: '',
        role: '',
      },
      errorMessage: {},
      error: '',
      defaults: [],
    };
    this.initRoles(props.t);
  }

  initRoles(t) {
    this.superAdminRolesDropdown = [
      {
        label: t('role.superAdmin', 'Superadmin'),
        value: t('role.superAdmin', 'Superadmin'),
        val: appEnum.Role.SuperAdmin,
      },
    ];

    this.userRolesDropdown = [
      {
        label: t('role.admin', 'Administratör'),
        value: t('role.admin', 'Administratör'),
        val: appEnum.Role.Management,
      },
      {
        label: t('role.participant', 'Deltagare'),
        value: t('role.participant', 'Deltagare'),
        val: appEnum.Role.Inköp,
      },
      {
        label: t('role.visitor', 'Besökare'),
        value: t('role.visitor', 'Besökare'),
        val: appEnum.Role.Kalkyl,
      },
      {
        label: t('role.client', 'Beställare'),
        value: t('role.client', 'Beställare'),
        val: appEnum.Role.Client,
      },
    ];
  }

  componentDidUpdate(prevProps) {
    const {t} = this.props;
    if (t !== prevProps.t) {
      this.initRoles(t)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props != nextProps) {
      const _project = (nextProps.projects.data ?? []).map(p => ({ label: p.name, value: p.name, id: p._id }));
      this.setState({
        projects: _project,
      });
      if (!_.isEqual(this.props.currentMember, nextProps.currentMember) && nextProps.currentMember) {
        const { email, role, projects } = nextProps.currentMember;
        let currentMemberData = {
          email,
          role,
          projects: _project,
        };
        const showSuperRoles = appState.isSuperAdminOrg() && appState.isSuperAdmin();
        const hasPurchasing = appState.isPurchasingActive();
        let roles = showSuperRoles ? this.superAdminRolesDropdown : (hasPurchasing ? this.userRolesDropdown : [this.userRolesDropdown[0]]);

        currentMemberData.role = roles.find(r => r.val === role) ?? roles[0];
        this.setState({ data: currentMemberData });

        const projectsData = nextProps.currentMember.projects;
        if (projectsData?.length) {
          let projects = [];
          if (projectsData[0].projectId?._id) {
            projects = projectsData
              .filter(project => project.projectId?._id)
              .map(project => ({
                label: project.projectId?.name,
                value: project.projectId?.name,
                _id: project.projectId?._id,
                id: project.projectId?._id,
                areaIds: project.areaIds,
              }));
          } else {
            projects = this.state.projects.filter(p1 => projectsData.some(p2 => p1.id === p2.projectId));
          }
          this.setState({
            defaults: [...projects],
            error: '',
          });
        } else
          this.setState({
            defaults: [],
          });
      }
    }
  }

  reset = () => {
    this.setState({
      errorMessage: {},
      error: '',
      defaults: [],
      data: {
        email: '',
        role: '',
      },
    });
  }

  onClose = () => {
    this.reset();
    if (this.props.onClose) this.props.onClose();
  };

  onSelectProject = projects => {
    this.setState({
      defaults: [...projects],
    });
  };

  handleChange = (value, name) => {
    const { errorMessage } = this.state;
    let data = this.state.data;
    if (value.label) data.role = value;
    else data[name] = value;
    if(Object.values(errorMessage).length) {
      errorMessage[name] = '';
      this.setState({ errorMessage });
    }
    this.setState({ data });
  };

  getRemovedProjectsForUser = async (projects) => {
    const { currentMember } = this.props;
    const oldProjects = currentMember?.projects;
    let oldProjectsClone = _.cloneDeep(oldProjects);

    await oldProjectsClone.map((project, i) => {
      let projectFound = projects.find(p =>  p.projectId === project.projectId?._id);
      if(!projectFound){
        oldProjectsClone[i].removed = true;
        oldProjectsClone[i].projectId = oldProjectsClone[i].projectId._id;
      }
    });
    oldProjectsClone = oldProjectsClone.filter(p => p.removed);
    return [...oldProjectsClone, ...projects];
  }

  getProjectsForUser = async () => {
    const { defaults = [] } = this.state;
    const { currentMember } = this.props;
    return await defaults.map(project => {
      const userProjects = currentMember?.projects;
      let areaIds = [];
      if(userProjects?.length){
        let projectFound = userProjects.find(p => p.projectId?._id == project.id);
        if(projectFound?.areaIds) areaIds = projectFound.areaIds;
      }
      return({ projectId: project.id, startDate: new Date(), areaIds });
    })
  }

  validateData = () => {
    const { t } = this.props;
    const { data } = this.state;
    const errorMessage = {};

    if(!data.email) errorMessage.email = t('validation:requiredField', 'Obligatoriskt fält');
    else if(validateEmail(data.email)) errorMessage.email = validateEmail(data.email);

    if(!data.role) errorMessage.role = t('validation:requiredField', 'Obligatoriskt fält');

    this.setState({ errorMessage })
    return Object.values(errorMessage).length;
  }

  handleSubmit = async () => {
    const { t } = this.props;
    const { data } = this.state;
    const { currentMember } = this.props;

    if(this.validateData()) return;

    try {
      this.setState({ error: '' });
      this.props?.toggleBtnLoader(true);
      // Add member
      let _data = {
        email: data.email,
        role: data.role.val,
        projects: await this.getProjectsForUser(),
      };
      let response;
      if (currentMember) {
        _data.projects = await this.getRemovedProjectsForUser(_data.projects);
        let userData = await Object.assign(currentMember, _data);
        response = await serviceProfile.dbUpdateMember(userData);

        this.props?.updateMemberLocally(response?.data);
      } else {
        response = await serviceProfile.dbAddMember(_data);
        if (response.status == 200 && response?.user) this.props?.addMemberLocally(response?.user);
      }
      if (response.status == 200) {
        NotificationManager.success(t('notification.success', 'Sparad'));
      } else {
        NotificationManager.error(t('notification.error', 'Ett fel inträffade'));
      }

      this.onClose();
    } catch (e) {
      this.handleError(e);
    } finally {
      this.props?.toggleBtnLoader(false);
    }
  };

  handleError = (e) => {
    const { t } = this.props;
    const errorKey = e?.response?.data?.error || 'error.unexpectedError';
    const errorMessage = t(errorKey, {ns: 'auth'});

    if(errorKey == 'error.emailalreadytaken') this.setState({ errorMessage: { email: errorMessage }});
    else this.setState({ error: errorMessage });

    console.log({ errorKey, errorMessage });
  }

  renderFormSlide = () => {
    const { t } = this.props;
    const { error, data, projects, defaults, errorMessage } = this.state;
    const { currentMember } = this.props;
    const isSuperAdmin = appState.getCurrentOrgSlug() === 'superadmin' && appState.isSuperAdmin();
    const hasPurchasing = appState.isPurchasingActive();
    const isNonAdminUser = appState.isNonAdminUser();

    return (
      <div className="member-modal">
        <div className={`error ${error ? 'show' : 'hide'}`}>
         <p>{_.isObject(error) ? t('error.unknownError', 'Ett fel inträffade') : error}</p>
        </div>

        <Field
          label={t('label.email', 'E-post')}
          required
          value={data.email}
          onChange={(val) => this.handleChange(val, 'email')}
          errorMessage={errorMessage?.email}
          style={{ fontSize: '14px' }}
          disabled={!!currentMember}
          className={`${currentMember ? 'disabled' : ''}`}
        />
        <Selector
          label={t('label.role', 'Roll')}
          required
          options={isSuperAdmin ? this.superAdminRolesDropdown : (hasPurchasing ? this.userRolesDropdown : [this.userRolesDropdown[0]])}
          placeholder={t('placeholder.role', 'Välj')}
          value={data.role}
          onChange={val => this.handleChange(val, 'role')}
          errorMessage={errorMessage?.role}
          isDisabled={isNonAdminUser}
        />

        {!isSuperAdmin && hasPurchasing && (
          <Selector
            label={t('label.projects', 'Projekt')}
            placeholder={t('placeholder.projects', 'Välj')}
            isMulti
            options={projects}
            value={defaults}
            onChange={this.onSelectProject}
          />
        )}
      </div>
    );
  };

  render() {
    const { data } = this.state;

    return (
      <div className="app-add-supplier app-create-project" ref={el => (this.element = el)}>
        <div className="page-paddings">
          <BtGrid>
            <BtRow>
              <BtColumn className="colum-left pp-col-left">
                <div className="content-left">
                  {data && (
                    <Formik>
                      {({ resetForm }) => (
                        <Form autoComplete="off">
                          <div className="mx-content">
                            {this.renderFormSlide()}
                          </div>
                        </Form>
                      )}
                    </Formik>
                  )}
                </div>
              </BtColumn>
            </BtRow>
          </BtGrid>
        </div>
      </div>
    );
  }
}

export default withTranslation(['users', 'auth', 'validation'], { withRef: true })(AddMember);
